export const changeshowModisNDVIDotReducer = (state = false, action) => {
  switch (action.type) {
    case "CHANGE_showModisNDVIDot":
      return action.payload.showModisNDVIDot;
    default:
      return state;
  }
};
